import axios from "axios";
import store from "../stateManagement/store";
import { faCodeCompare, faMobileScreen, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { EnvironmentRegistry } from "../services/registry/environmentRegistry"
import { getDataFromCache } from "./cachingService";
import { ChannelkartNetworkGet } from "./networkService";
import { openPopup } from "../stateManagement/actions/popupActions";
import { getAccessToken } from "./authenticationService";
import { getAuthServiceState } from "./salescodeAuthService";


export const dataQueries = {
  top5Sku: "/v3/analyticsreport/custom?queryName=top5skuCmtd",
  top5Categories: "/v3/analyticsreport/custom?queryName=top5catagoriesCmtd",
  top5Retailers: "/v3/analyticsreport/custom?queryName=top5retailersCmtd",
  bottom5Sku: "/v3/analyticsreport/custom?queryName=bottom5skuCmtd",
  bottom5Retailers: "/v3/analyticsreport/custom?queryName=bottom5retailersCmtd",
  bottom5Categories: "/v3/analyticsreport/custom?queryName=bottom5catagoriesCmtd"
}


export const userTableQueries = {
  logged: "/v3/analyticsreport/custom?queryName=user-logged&source=portal&callType=scheduled",
  loggedNotOrdered: "/v3/analyticsreport/custom?queryName=logged-not-ordered&source=portal&callType=scheduled",
  todayOrdered: "/v3/analyticsreport/custom?queryName=orderedUsersReportInDateRange&source=portal&callType=scheduled"
}

export const typeOfHeaders = {
  skus: "Sku",
  categories: "Categories",
  retailers: "Retailers",
  skuBottom: "Sku",
  categoriesBottom: "Categories",
  retailersBottom: "Retailers",
  top5: "TOP 5",
  bottom5: "BOTTOM 5"
}


export const displayHeaderMapList: displayHeaderMap[] = [
  {
    attribute: "category",
    displayName: "Category"
  },
  {
    attribute: "sku_code",
    displayName: "Sku Code"
  },
  {
    attribute: "sku_description",
    displayName: "SKU Description"
  },
  {
    attribute: "value",
    displayName: "Value"
  },
  {
    attribute: "name",
    displayName: "Name"
  },
  {
    attribute: "loginid",
    displayName: "LoginId"
  }
]

export type displayHeaderMap = {
  attribute: string,
  displayName: string
}

export const getAnalyticsUserData = async () => {
  const lob = EnvironmentRegistry.getCurrentLob()
  const url = `https://traffic.saleslens.salescode.ai/usertraffic/${lob}`
  const data = await axios.get(url);
  return data;
};

export const getUserAnalyticsLobConfig = () => {

  // In future if we agree to save it in db as per all 
  // lob then we need to change code here and return config data here 

  const data = [
    {
      heading: "ACTIVE USERS",
      subHeading: "Today",
      footerHeading: "Current Week",
      img: "faMobileScreen",
      api: "/v1/query/AwareToday",
      api2: "/v1/query/AwareTotal",
      callApi: false,
      primaryValue: "dau.daily.count",
      secondaryValue: "",
    },
    {
      heading: "MTD ACTIVE USERS",
      subHeading: "Current Month",
      footerHeading: "Last Month",
      img: "faUser",
      api: "/v1/query/OnboardingToday",
      api2: "/v1/query/OnboardingTotal",
      callApi: false,
      primaryValue: "mau.monthly.count",
      secondaryValue: "",
    },
    {
      heading: "INACTIVE USERS",
      subHeading: "Today",
      footerHeading: "Current Week",
      img: "faUsers",
      api: "/v1/query/RepeatToday",
      api2: "/v1/query/RepeatTotal",
      callApi: false,
      primaryValue: "api-/v3/analyticsreport-inactiveUsersCountOfDateRange-Today-portal-scheduled",
      secondaryValue: "api-/v3/analyticsreport-inactiveUsersCountOfDateRange-Current Week-portal-scheduled",
    },
    {
      heading: "PTD INACTIVE USERS",
      subHeading: "Current Period",
      footerHeading: "Last Period",
      img: "faUsers",
      api: "/v1/query/AdoptedToday",
      api2: "/v1/query/AdoptedTotal",
      callApi: false,
      primaryValue: "api-/v3/analyticsreport-inactiveUsersCountOfDateRange-Current Month-portal-scheduled",
      secondaryValue: "api-/v3/analyticsreport-inactiveUsersCountOfDateRange-Last Month-portal-scheduled",
    }
  ]

  return data;
}

export const getValueFromPath = (obj: Record<string, any>, path: string): any => {
  const keys = path.split('.');
  let result = obj;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return 0;
    }
  }
  return result;
};

export const getIcons = (iconName: string) => {
  switch (iconName) {
    case "faCodeCompare": {
      return faCodeCompare;
    }
    case "faMobileScreen": {
      return faMobileScreen;
    }
    case "faUser": {
      return faUser;
    }
    case "faUsers": {
      return faUsers;
    }
    default: {
      return faUser;
    }
  }
}
export const getTableData = (async (query: string) => {
  const queryResponse = await getDataFromCache(query, 15, async () => {
    const response = await ChannelkartNetworkGet(query);
    return response;
  });
  return (queryResponse?.data?.features);

});

export const getAnalyticsChartData = async (apiEndPoint: string, fromDateChart2: string, toDate: string, sortBy?: string) => {
  let url = `${apiEndPoint}&fromDate=${fromDateChart2}&toDate=${toDate}`
  if (sortBy && sortBy.trim() !== '')
    url = url + `&sortBy=${sortBy}`;
  const queryResponse = await getDataFromCache(url, 15, async () => {
    const response = await ChannelkartNetworkGet(url);
    return response;
  });
  return queryResponse.data.features;
};

export const getCardData = async (apiEndPoint: string, queryName: string, dateRange: string, source: string, callType: string, sortBy?: string) => {
  const { startDate, endDate } = getDateRange(dateRange);
  const response = await getCardDataThroughQuery(
    apiEndPoint,
    queryName,
    startDate,
    endDate,
    source,
    callType,
    sortBy);
  return response[0]?.value;
}

export const getCardDataThroughQuery = async (apiEndPoint: string, queryName: string, fromDateChart2: string, toDate: string, source: string, callType: string, sortBy?: string) => {

  let url = `${apiEndPoint}/${queryName}/?fromDate=${fromDateChart2}&toDate=${toDate}&source=${source}&callType=${callType}`
  if (sortBy && sortBy.trim() !== '')
    url = url + `&sortBy=${sortBy}`;
  const queryResponse = await getDataFromCache(url, 15, async () => {
    const response = await ChannelkartNetworkGet(url);
    return response;
  });
  return queryResponse?.data?.features;
}

export const getDateRange = (filterDate: string): { startDate: string; endDate: string } => {
  const currentDate = new Date();
  let startDate: Date;
  let endDate: Date;

  switch (filterDate) {
    case "Current Week":
      startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - (currentDate.getDay() - 1)); // Monday of the current week
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // Sunday of the current week
      break;
    case "Last Week":
      const lastWeekStartDate = new Date(currentDate);
      lastWeekStartDate.setDate(currentDate.getDate() - (currentDate.getDay() - 1) - 7); // Monday of last week
      const lastWeekEndDate = new Date(lastWeekStartDate);
      lastWeekEndDate.setDate(lastWeekStartDate.getDate() + 6); // Sunday of last week
      startDate = lastWeekStartDate;
      endDate = lastWeekEndDate;
      break;
    case "Current Month":
      startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      endDate.setHours(23, 59, 59, 999);
      break;
    case "Last Month":
      const lastMonthStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
      startDate = lastMonthStartDate;
      startDate.setHours(0, 0, 0, 0);
      const lastMonthEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      endDate = lastMonthEndDate;
      endDate.setHours(23, 59, 59, 999);
      break;
    case "Today":
      startDate = new Date(currentDate);
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(currentDate);
      endDate.setHours(23, 59, 59, 999);
      break;
    default:
      throw new Error("Invalid filterDate");
  }
  return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day}%20${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export const getOutletStats = async () => {
  const data = [
    {
      "sourceCount": {
        "app order": 6
      },
      "outletcode": "0504738320",
      "loginid": "0504738320",
      "parents": [
        "STL0567",
        "0505258531",
        "admin@applicate.in",
        "G74",
        "admin",
        "1592",
        "015374"
      ],
      "amount": 6672.3,
      "systemAmount": 6672.3,
      "extAmount": 0,
      "count": 6,
      "selfCount": 5,
      "firstOrderTime": "2023-08-17T13:45:17.320Z",
      "lastOrderTime": "2024-01-26T16:05:10Z",
      "selfOrderAmount": 6070.46
    },
    {
      "sourceCount": {
        "app order": 8,
        "PWA": 2,
        "SFA Mobile": 2
      },
      "outletcode": "0502981780",
      "loginid": "0502981780",
      "parents": [
        "STL0567",
        "0505258531",
        "admin@applicate.in",
        "G74",
        "admin",
        "1592",
        "015374"
      ],
      "amount": 193621.01,
      "systemAmount": 125163.01000000002,
      "extAmount": 68458,
      "count": 12,
      "selfCount": 3,
      "firstOrderTime": "2023-08-18T10:18:12.044Z",
      "lastOrderTime": "2024-01-24T03:11:25.031Z",
      "selfOrderAmount": 52060.46
    },
    {
      "sourceCount": {
        "app order": 10,
        "CORDOVA": 1
      },
      "outletcode": "0503525716",
      "loginid": "0503525716",
      "parents": [
        "STL0567",
        "0505258531",
        "admin@applicate.in",
        "G74",
        "admin",
        "1592",
        "015374"
      ],
      "amount": 145303.43999999997,
      "systemAmount": 145303.43999999997,
      "extAmount": 0,
      "count": 11,
      "selfCount": 2,
      "firstOrderTime": "2023-08-05T12:47:36.659Z",
      "lastOrderTime": "2024-02-01T17:38:35Z",
      "selfOrderAmount": 29416.3
    },
    {
      "sourceCount": {
        "app order": 13,
        "SFA Mobile": 1,
        "CORDOVA": 2
      },
      "outletcode": "0505385398",
      "loginid": "0505385398",
      "parents": [
        "STL0567",
        "0505258531",
        "admin@applicate.in",
        "G74",
        "admin",
        "1592",
        "015374"
      ],
      "amount": 74473.81,
      "systemAmount": 49383.81,
      "extAmount": 25090,
      "count": 16,
      "selfCount": 2,
      "firstOrderTime": "2023-08-07T17:40:48.688Z",
      "lastOrderTime": "2024-01-24T13:43:33Z",
      "selfOrderAmount": 8480.96
    }
  ];
  const loginid = JSON.parse(localStorage.authContext).user.loginId;
  let url = `/outlets/${loginid}`;
  const queryResponse = await getDataFromCache(url, 15, async () => {
    const response = await ChannelkartNetworkGet(url);
    return response;
  });
  return data;
}

export const getUserStats = async () => {

  // let url = `https://saleslens.salescode.ai/stats/admin@applicate.in?accountId=jnjphaiuat`;

  // const headers = {
  //   'accept': 'application/json, text/plain, */*',
  //   'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
  //   'cookie': `jwt=${sessionStorage.getItem("access_token")};` , 
  //   'Access-Control-Allow-Origin': 'true',
  // };

  // const response1 = await axios.get(url, {
  //   headers: headers
  // });

  // const data = await axios.get(url);
  // const headers:HttpHeaders = {
  //   'Access-Control-Allow-Origin': 'true',
  // };
  // const response = await ChannelkartNetworkGet(url, headers);


  const loginid = JSON.parse(localStorage.authContext).user.loginId;
  let url = `/v3/stats/${loginid}`;
  const queryResponse = await getDataFromCache(url, 15, async () => {
    const response = await ChannelkartNetworkGet(url);
    return response;
  });
  return queryResponse;
}
export function formatNumberWithCommas(value: string | number): string {
  const number = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(number)) {
    return '';  
  }
  return number.toLocaleString();
}

export async function fetchUserAnalytics(){
  const lob = EnvironmentRegistry.getCurrentLob();
  const authContext = localStorage.getItem("authContext");
  const user = authContext ? JSON.parse(authContext).user.loginId : null;
  const url = `https://datanode.saleslens.salescode.ai/stats/admin@applicate.in?accountId=${lob}`;
  const token = getAccessToken() ?? "";
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    openPopup("Alert","Error while fetching User data");
  }
}

export const getSaleslensData = async (coeAPI?: Boolean,type?: string) => {
  const lob = EnvironmentRegistry.getCurrentLob();
  const authContext = localStorage.getItem("authContext");
  const user = authContext ? JSON.parse(authContext).user.loginId : null;
  let url = `https://traffic.saleslens.salescode.ai/ordervalues/${lob}/admin@applicate.in`;
  if(coeAPI){
    url = `https://traffic.saleslens.salescode.ai/coeordertraffic/${lob}/admin@applicate.in/${type}/secondary`;
  }
  const response = await getAuthServiceState(); 
  const isAuthService = response.isAuthService
  const token = getAccessToken() ?? "";
  try {
    const response = await axios.get(url,{
      headers: {
        Authorization: token,
        Source: "portal",
        Env: localStorage.getItem("env") ?? "", 
        AuthConfig: isAuthService,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching saleslens data:", error);
    openPopup("Alert","Error while fetching Saleslens data");
  }
};

export function findTodayCountAndValue(data:any) {
  const { startDate } = getDateRange("Today");
  const decodedStartDate = decodeURIComponent(startDate);
  const today = decodedStartDate.split(' ')[0];
  // console.log("Today",today)
  const dailyStats = data?.orderStats?.daily;
  const todayStat = dailyStats?.find((stat:any) => {
    const statDate = stat.dateKey.split('T')[0]; 
    return statDate === today;
  });
  if (todayStat) {
    return {
      count: todayStat.count,
      value: todayStat.value
    };
  } else {
    return {
      count: null,
      value: null
    };
  }
}
export function findLastWeekCountAndValue(data:any) {
  const { startDate } = getDateRange("Last Week");
  const decodedStartDate = decodeURIComponent(startDate);
  const today = decodedStartDate.split(' ')[0];
  // console.log("Last Week",today)
  const dailyStats = data?.orderStats?.weekly;
  const todayStat = dailyStats?.find((stat:any) => {
    const statDate = stat.dateKey.split('T')[0]; 
    return statDate === today;
  });
  if (todayStat) {
    return {
      count: todayStat.count,
      value: todayStat.value
    };
  } else {
    return {
      count: null,
      value: null
    };
  }
}
export function findLastMonthCountAndValue(data:any,coeAPI?: Boolean) {
  const { startDate } = getDateRange("Last Month");
  const decodedStartDate = decodeURIComponent(startDate);
  let today = decodedStartDate.split(' ')[0];
  if (coeAPI) {
    // convert "2025-10-01" → "2025-10"
    today = today.slice(0, 7);
  }
  // console.log("Last Month",today)
  const dailyStats = data?.orderStats?.monthly;
  const todayStat = dailyStats?.find((stat:any) => {
    const statDate = stat.dateKey.split('T')[0]; 
    return statDate === today;
  });
  if (todayStat) {
    return {
      count: todayStat.count,
      value: todayStat.value
    };
  } else {
    return {
      count: null,
      value: null
    };
  }
}
export function findCurrentMonthCountAndValue(data:any,coeAPI?: Boolean) {
  const { startDate } = getDateRange("Current Month");
  const decodedStartDate = decodeURIComponent(startDate);
  let today = decodedStartDate.split(' ')[0];
  // console.log("Current Month",today)
  if (coeAPI) {
    // convert "2025-10-01" → "2025-10"
    today = today.slice(0, 7);
  }
  const dailyStats = data?.orderStats?.monthly;
  const todayStat = dailyStats?.find((stat:any) => {
    const statDate = stat.dateKey.split('T')[0]; 
    return statDate === today;
  });
  if (todayStat) {
    return {
      count: todayStat.count,
      value: todayStat.value
    };
  } else {
    return {
      count: null,
      value: null
    };
  }
}

export function sumCountsInRange(data:any, startDate:any, endDate:any) {
  const dailyStats = data?.orderStats?.daily;
  const start = new Date(startDate);
  const end = new Date(endDate);
  // console.log("startDate",startDate)
  // console.log("endDate",endDate)
  const filteredStats = dailyStats?.filter((stat:any) => {
    const statDate = new Date(stat.dateKey);
    return statDate >= start && statDate <= end;
  });
  const totalCount = filteredStats?.reduce((sum: any, stat: any) => sum + stat.count, 0);
  const totalValue = filteredStats?.reduce((sum: any, stat: any) => sum + parseFloat(stat.value), 0);
  if (filteredStats) {
    return {
      count: totalCount,
      value: totalValue
    };
  } else {
    return {
      count: null,
      value: null
    };
  }
}
export function findCurrentWeekCountAndValue(data:any) {
  const { startDate } = getDateRange("Current Week");
  const decodedStartDate = decodeURIComponent(startDate);
  const today = decodedStartDate.split(' ')[0];
  // console.log("Last Week",today)
  const dailyStats = data?.mau?.weekly;
  const todayStat:any = dailyStats?.find((stat:any) => {
    const statDate = stat.dateKey.split('T')[0]; 
    return statDate === today;
  });
  return todayStat?.count;
}

export function formatNumberWithCommasHomologated(value: string | number): string {
  const number = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(number)) {
    return '';  
  }
  return number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
